import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/system";
import { useMediaQuery } from "@mui/material";

type Props = {
  title: string;
};

const PageTitle = ({ title }: Props) => {
  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm"),
  );

  return (
    <Box
      display="flex"
      flexDirection={isSmallScreen ? "column" : "row"}
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography
        variant="h5"
        component="h2"
        gutterBottom
        style={{ marginBottom: isSmallScreen ? "16px" : "0" }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default PageTitle;
